export default "/images/avatarka.png?cb79fa200b0c492ae6ef6e840a1e0971";